import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { GraduationCap } from 'blaze-ui/icons'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { NoAccountsContent } from './NoAccountsFoundContent'
import { getConnectionGuide } from './utils'
import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button as BlazeButton } from 'blaze-ui/Button'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'
import Styles from './NoAccountsFound.module.scss'

interface NoAccountsFoundDrawerProps extends DrawerProps {
  provider: ExternalIntegrationEnum
  onClose: () => void
}

export const NoAccountsFoundDrawer = ({ provider, onClose, ...props }: NoAccountsFoundDrawerProps) => {
  const connectionGuide = getConnectionGuide(provider)
  const openWindowSafely = useOpenWindowSafely()
  const { drawersStore } = useRootStore()

  const handleClose = () => {
    drawersStore.closeDrawer()
    onClose()
  }

  return (
    <Drawer.Root {...props} onClose={handleClose}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div>
                <Button onPress={handleClose}>Cancel</Button>
              </div>
              <Drawer.Title asChild>
                <Heading level={5}>We couldn't find any accounts</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container>
              <NoAccountsContent provider={provider} />
              {connectionGuide && (
                <div className={Styles.buttonContainer}>
                  <BlazeButton
                    size="lg"
                    fullWidth
                    variant="primary"
                    frontIcon={GraduationCap}
                    onPress={() => openWindowSafely(connectionGuide)}
                  >
                    See Connection Guide
                  </BlazeButton>
                </div>
              )}
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
